import { render, staticRenderFns } from "./BigSlider.vue?vue&type=template&id=253f42f1&scoped=true&"
import script from "./BigSlider.vue?vue&type=script&lang=js&"
export * from "./BigSlider.vue?vue&type=script&lang=js&"
import style0 from "./BigSlider.vue?vue&type=style&index=0&id=253f42f1&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "253f42f1",
  null
  
)

export default component.exports


//////////////////
// WEBPACK FOOTER
// ./scripts/vue/BigSlider.vue
// module id = 228
// module chunks = 0